export enum Language {
    English = "English",
    TeReo = "Te Reo Maori"
}
